export const contentConstant = {
  typeId: 0,
  typeName: null,

  isSectionTypeListRequired: false,

  isSingleImageRequired: false,
  singleImageUploadName: null,
  isSingleImageCroperRequired: false,
  singleImageCropRatio: null,
  singleImageMaxWidth: null,

  isMultipleImageRequired: false,
  multipleImageUploadName: null,
  isMultipleImageCroperRequired: false,
  multipleImageCropRatio: null,
  multipleImageMaxWidth: null,

  isTitleRequired: false,
  titleName: null,

  isSubTitleRequired: false,
  subTitleName: null,

  isDescriptionRequired: false,
  descriptionName: null,

  isDescriptionListRequired: false,

  isDescriptionListHeaderRequired: false,
  descriptionListHeaderName: null,

  isDescriptionListTitleRequired: false,
  descriptionListTitleName: null,

  isDescriptionListContentRequired: false,
  descriptionListContentName: null,

  isDateRequired: false,
  dateName: null,

  isAttachmentRequired: false,
  attachementName: null,

  isYearRequired: false,
  yearName: null,

  isMonthRequired: false,
  monthName: null,

  isDateRangeRequired: false,
  dateRangeName: null,

  isMinAgeRequired: false,
  minAgeName: null,
};

export const contentTypeConfig = [
  {
    typeId: 1,
    typeName: "Home Banner",

    isSectionTypeListRequired: true,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Banner Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 1600,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 2,
    typeName: "News Bar Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: false,
    singleImageUploadName: null,
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: null,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "News Title",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: true,
    attachementName: "News Attachment",

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 3,
    typeName: "Inclusive Community Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Inclusive Community Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "1:1",
    singleImageMaxWidth: 600,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Title",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Content",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 4,
    typeName: "Explore Meridian School Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "2:1",
    singleImageMaxWidth: 1000,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Title",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 5,
    typeName: "Life at Meridian School Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 600,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Title",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: true,
    descriptionName: "Short Description",

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 6,
    typeName: "Parent Testimonial Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "1:1",
    singleImageMaxWidth: 450,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Title",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Testimonial Content",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 7,
    typeName: "School Events Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Event Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 450,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Title",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: true,
    dateName: "Event Date",

    isAttachmentRequired: true,
    attachementName: "Event Attachment/Link",

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 8,
    typeName: "Trusted Collaborators",

    isSectionTypeListRequired: true,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Collaborator Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:1",
    singleImageMaxWidth: 200,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 9,
    typeName: "About Us - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 10,
    typeName: "About Meridian School - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "1:1",
    singleImageMaxWidth: 500,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Title",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Content",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 11,
    typeName: "What Makes Us Unique - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "1:1",
    singleImageMaxWidth: 500,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Title",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: true,
    descriptionListHeaderName: "Quote About Uniqueness",

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Content",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 12,
    typeName: "The 5E's Model for Learning  - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "1:1",
    singleImageMaxWidth: 500,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Title",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Content",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 13,
    typeName: "Our Multiple Intelligence - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "1:1",
    singleImageMaxWidth: 500,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Title",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Content",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 14,
    typeName: "Level 1 Highlights About Meridian - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "1:1",
    singleImageMaxWidth: 500,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Content",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 15,
    typeName: "Level 2 Highlights About Meridian - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "1:1",
    singleImageMaxWidth: 500,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Content",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 16,
    typeName: "Meridian Acheivements",

    isSectionTypeListRequired: true,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "1:1",
    singleImageMaxWidth: 300,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Title",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 17,
    typeName: "Vision & Mision - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 18,
    typeName: "Our Vision - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "2:1",
    singleImageMaxWidth: 1280,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: true,
    descriptionName: "Short Description",

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 19,
    typeName: "Our Mission - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "2:1",
    singleImageMaxWidth: 1280,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: true,
    descriptionName: "Short Description",

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 20,
    typeName: "Meridian Leadership - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 21,
    typeName: "Our Visionary Leaders - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "1:1",
    singleImageMaxWidth: 650,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Leader Name",

    isSubTitleRequired: true,
    subTitleName: "Leader Designation",

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Leader Bio",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 22,
    typeName: "Awards & Accolades - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 23,
    typeName: "Meridian Champions - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "2:1",
    singleImageMaxWidth: 1280,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Title",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: true,
    descriptionName: "Short Description",

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 24,
    typeName: "Student Achievements - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Student Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "1:1",
    singleImageMaxWidth: 450,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Student Name",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Achievement Details",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 25,
    typeName: "Mandatory Public Disclosure - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 26,
    typeName: "General Information - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: false,
    singleImageUploadName: null,
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: null,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: true,
    descriptionListTitleName: "Information Title",

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Information Content",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 27,
    typeName: "Mandatrory Public Disclosure 1 - Documents",

    isSectionTypeListRequired: true,

    isSingleImageRequired: false,
    singleImageUploadName: null,
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: null,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Document Title",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: true,
    attachementName: "Add Attachment",

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 28,
    typeName: "Mandatrory Public Disclosure 2 - Documents",

    isSectionTypeListRequired: true,

    isSingleImageRequired: false,
    singleImageUploadName: null,
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: null,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Document Title",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: true,
    attachementName: "Add Attachment",

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 29,
    typeName: "Academics - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 30,
    typeName: "Academics Welcome Section - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "1:1",
    singleImageMaxWidth: 600,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Title",

    isSubTitleRequired: true,
    subTitleName: "Sub Title",

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 31,
    typeName: "Meridian School Uppal Campus - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "2:1",
    singleImageMaxWidth: 1280,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: true,
    descriptionName: "Uppal Campus Welcome Description",

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 32,
    typeName: "Student Approach - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:4",
    singleImageMaxWidth: 500,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Title",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Content",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 33,
    typeName: "About Our Faculty - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "2:1",
    singleImageMaxWidth: 1280,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Title",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: true,
    descriptionName: "Short Description",

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 34,
    typeName: "About Our Classrooms - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: false,
    singleImageUploadName: null,
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: null,

    isMultipleImageRequired: true,
    multipleImageUploadName: "Upload Classroom Images",
    isMultipleImageCroperRequired: true,
    multipleImageCropRatio: "3:2",
    multipleImageMaxWidth: 400,

    isTitleRequired: true,
    titleName: "Title",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: true,
    descriptionName: "Short Description",

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 35,
    typeName: "FAQ on Fee Structure - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: false,
    singleImageUploadName: null,
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: null,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Question",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: true,
    descriptionName: "Answer",

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 36,
    typeName: "Teaching Style - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 37,
    typeName: "Experienced Faculty - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 110,
    typeName: "School Higher Management - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "1:1",
    singleImageMaxWidth: 250,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Coordinator Name",

    isSubTitleRequired: true,
    subTitleName: "Coordinator Designation",

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 38,
    typeName: "Academic Coordinators - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "1:1",
    singleImageMaxWidth: 250,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Coordinator Name",

    isSubTitleRequired: true,
    subTitleName: "Coordinator Designation",

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 39,
    typeName: "High School Teachers - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "1:1",
    singleImageMaxWidth: 250,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Teacher Name",

    isSubTitleRequired: true,
    subTitleName: "Teacher Designation",

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 40,
    typeName: "Middle School Teachers - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "1:1",
    singleImageMaxWidth: 250,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Teacher Name",

    isSubTitleRequired: true,
    subTitleName: "Teacher Designation",

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 41,
    typeName: "Primary School Teachers - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "1:1",
    singleImageMaxWidth: 250,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Teacher Name",

    isSubTitleRequired: true,
    subTitleName: "Teacher Designation",

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 42,
    typeName: "Language Teachers - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "1:1",
    singleImageMaxWidth: 250,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Teacher Name",

    isSubTitleRequired: true,
    subTitleName: "Teacher Designation",

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 43,
    typeName: "Activity Teachers - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "1:1",
    singleImageMaxWidth: 250,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Teacher Name",

    isSubTitleRequired: true,
    subTitleName: "Teacher Designation",

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 44,
    typeName: "Administration Department - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "1:1",
    singleImageMaxWidth: 250,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Administration Staff Name",

    isSubTitleRequired: true,
    subTitleName: "Administration Staff Designation",

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 45,
    typeName: "Academics FAQ - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 46,
    typeName: "FAQ's on Academics - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: false,
    singleImageUploadName: null,
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: null,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Question",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: true,
    descriptionName: "Answer",

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 47,
    typeName: "FAQ's on Assessments - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: false,
    singleImageUploadName: null,
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: null,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Question",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: true,
    descriptionName: "Answer",

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 48,
    typeName: "Newsletters - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 49,
    typeName: "Newsletters - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "1:1",
    singleImageMaxWidth: 300,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: true,
    attachementName: "Upload Newsletter Document/Link",

    isYearRequired: true,
    yearName: "Academic Start Year",

    isMonthRequired: true,
    monthName: "Newsletter Month",

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 50,
    typeName: "Academics Doc - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 51,
    typeName: "Academic Documents - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: false,
    singleImageUploadName: null,
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: null,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Document Title",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: true,
    attachementName: "Add Attachment/Link",

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 52,
    typeName: "Training - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 53,
    typeName: "Staff Training Sessions - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "1:1",
    singleImageMaxWidth: 500,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Session Title",

    isSubTitleRequired: true,
    subTitleName: "Trainer Name & Designation",

    isDescriptionRequired: true,
    descriptionName: "Short Description",

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 54,
    typeName: "Circular List - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: false,
    singleImageUploadName: null,
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: null,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Title",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: true,
    attachementName: "Add Circular Document/Link",

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 55,
    typeName: "Senior Secondary - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 56,
    typeName: "Training Sessions - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "5:3",
    singleImageMaxWidth: 500,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Session Title",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Session Details",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 57,
    typeName: "Curriculum Support Program - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 58,
    typeName: "Curriculum Support Program - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 400,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Title",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: true,
    descriptionName: "Short Description",

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 59,
    typeName: "Sports - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 60,
    typeName: "Sports Activities - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "2:1",
    singleImageMaxWidth: 1280,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Title",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: true,
    descriptionName: "Short Description",

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 61,
    typeName: "Club & Activities - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 62,
    typeName: "Club & Activities - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: false,
    singleImageUploadName: null,
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: null,

    isMultipleImageRequired: true,
    multipleImageUploadName: "Upload Images",
    isMultipleImageCroperRequired: true,
    multipleImageCropRatio: "2:3",
    multipleImageMaxWidth: 300,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Club Details",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 63,
    typeName: "Liberty & Club - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: false,
    singleImageUploadName: null,
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: null,

    isMultipleImageRequired: true,
    multipleImageUploadName: "Upload Images",
    isMultipleImageCroperRequired: true,
    multipleImageCropRatio: "2:3",
    multipleImageMaxWidth: 300,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Club Details",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 64,
    typeName: "Art Club - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: 600,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Caption",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Club Details",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 65,
    typeName: "Quiz Club - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: 600,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Caption",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Club Details",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 66,
    typeName: "Dance Club - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: 600,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Caption",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Club Details",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 67,
    typeName: "Eco Club - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: 600,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: true,
    descriptionName: "Short Description",

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: true,
    descriptionListHeaderName: "Club Highlights Header",

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Club Details",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 68,
    typeName: "Music Club - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: 600,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Caption",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Club Details",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 69,
    typeName: "Sports Club - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: 600,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Caption",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Club Details",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 70,
    typeName: "Student Council - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:1",
    singleImageMaxWidth: 1280,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: true,
    descriptionName: "Short Description",

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 71,
    typeName: "Health & Wellness Club - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: 600,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Caption",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Club Details",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 72,
    typeName: "Drama & Theater Club - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: 600,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Caption",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Club Details",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 73,
    typeName: "FAQ's on Activities - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: false,
    singleImageUploadName: null,
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: null,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Question",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: true,
    descriptionName: "Answer",

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 74,
    typeName: "Mess Menu - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 75,
    typeName: "Transport SOP - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 76,
    typeName: "Transport Policy - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: false,
    singleImageUploadName: null,
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: null,

    isMultipleImageRequired: true,
    multipleImageUploadName: "Upload Images",
    isMultipleImageCroperRequired: true,
    multipleImageCropRatio: "1:1",
    multipleImageMaxWidth: 300,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Policy Details",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 77,
    typeName: "Student Corner - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 78,
    typeName: "Art & Craft - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: 400,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Student Name",

    isSubTitleRequired: true,
    subTitleName: "Class",

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 79,
    typeName: "Student Council - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 80,
    typeName: "Student Council - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "2:1",
    singleImageMaxWidth: 1280,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Title",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Council Details",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 81,
    typeName: "Student Council More Info - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:4",
    singleImageMaxWidth: 500,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: true,
    descriptionListTitleName: "Section Title",

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Section Content",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 82,
    typeName: "Why Student Council is important - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 500,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Quote",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: true,
    descriptionName: "Content",

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 83,
    typeName: "More Info on Student Council - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 500,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: true,
    descriptionListTitleName: "Section Title",

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Section Content",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 84,
    typeName: "Student Council Members - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: false,
    singleImageUploadName: null,
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: null,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Academic Year Title",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: true,
    attachementName: "Upload Document/Add Link",

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 85,
    typeName: "Admissions - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 86,
    typeName: "Admission Process - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:4",
    singleImageMaxWidth: 500,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Title",

    isSubTitleRequired: true,
    subTitleName: "Subtitle",

    isDescriptionRequired: true,
    descriptionName: "Short Description",

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: true,
    descriptionListHeaderName: "Section Header",

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Section Content",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 87,
    typeName: "Eligibility Criteria - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: false,
    singleImageUploadName: null,
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: null,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Class Name",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: true,
    dateName: "Cutoff Age as Date",

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: true,
    dateRangeName: "Date of Birth in Between",

    isMinAgeRequired: true,
    minAgeName: "Minimum Age",
  },
  {
    typeId: 88,
    typeName: "Admission Process FAQ - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: false,
    singleImageUploadName: null,
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: null,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Question",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: true,
    descriptionName: "Answer",

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 89,
    typeName: "Admission Process - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 90,
    typeName: "Admission Process Steps - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "1:1",
    singleImageMaxWidth: 500,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Step Title",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: true,
    descriptionName: "Step Description",

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 91,
    typeName: "Age Criteria - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 92,
    typeName: "Admission SOP - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 93,
    typeName: "About Age Criteria - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "1:1",
    singleImageMaxWidth: 500,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Title",

    isSubTitleRequired: true,
    subTitleName: "Highlights on Age Criteria",

    isDescriptionRequired: true,
    descriptionName: "Short Description",

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 94,
    typeName: "More Info on Admission - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "1:1",
    singleImageMaxWidth: 500,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: true,
    descriptionName: "Short Description",

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: true,
    descriptionListHeaderName: "Section Header",

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Section Content",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 95,
    typeName: "Admission FAQ's - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 96,
    typeName: "FAQ's on Admission Process - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: false,
    singleImageUploadName: null,
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: null,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Question",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: true,
    descriptionName: "Answer",

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 97,
    typeName: "Photo Gallery - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 98,
    typeName: "Photo Gallery - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: false,
    singleImageUploadName: null,
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: null,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Event Gallery Name",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: true,
    dateName: "Event Date",

    isAttachmentRequired: true,
    attachementName: "Event Attachment",

    isYearRequired: true,
    yearName: "Academic start Year",

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 99,
    typeName: "Kindergarten Kaleidoscope - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 100,
    typeName: "Kindergarten Kaleidoscope - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: false,
    singleImageUploadName: null,
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: null,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Event Gallery Name",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: true,
    attachementName: "Event Attachment",

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 101,
    typeName: "Video Gallery - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 102,
    typeName: "Video Gallery - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: false,
    singleImageUploadName: null,
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: null,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Video Name",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: true,
    attachementName: "Event Attachment",

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 103,
    typeName: "Contact For Admissions - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 104,
    typeName: "Contact Admission Process Steps - Content",

    isSectionTypeListRequired: false,

    isSingleImageRequired: false,
    singleImageUploadName: null,
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: null,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: true,
    descriptionName: "Short Description about Admissions",

    isDescriptionListRequired: true,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: true,
    descriptionListContentName: "Required Documents & Guidelines",

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 105,
    typeName: "Contact Admission FAQ's - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: false,
    singleImageUploadName: null,
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: null,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Question",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: true,
    descriptionName: "Answer",

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 106,
    typeName: "Contact For Career Opportunities - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 107,
    typeName: "Careers Admission Process Steps - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: false,
    singleImageUploadName: null,
    isSingleImageCroperRequired: false,
    singleImageCropRatio: null,
    singleImageMaxWidth: null,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Job Role Name",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 108,
    typeName: "Blogs - Banner Image",

    isSectionTypeListRequired: false,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "3:2",
    singleImageMaxWidth: 900,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: false,
    titleName: null,

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: false,
    descriptionName: null,

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,
  },
  {
    typeId: 109,
    typeName: "Blogs - Content",

    isSectionTypeListRequired: true,

    isSingleImageRequired: true,
    singleImageUploadName: "Upload Image",
    isSingleImageCroperRequired: true,
    singleImageCropRatio: "2:1",
    singleImageMaxWidth: 800,

    isMultipleImageRequired: false,
    multipleImageUploadName: null,
    isMultipleImageCroperRequired: false,
    multipleImageCropRatio: null,
    multipleImageMaxWidth: null,

    isTitleRequired: true,
    titleName: "Blog Title",

    isSubTitleRequired: false,
    subTitleName: null,

    isDescriptionRequired: true,
    descriptionName: "Blog Description",

    isDescriptionListRequired: false,

    isDescriptionListHeaderRequired: false,
    descriptionListHeaderName: null,

    isDescriptionListTitleRequired: false,
    descriptionListTitleName: null,

    isDescriptionListContentRequired: false,
    descriptionListContentName: null,

    isDateRequired: false,
    dateName: null,

    isAttachmentRequired: false,
    attachementName: null,

    isYearRequired: false,
    yearName: null,

    isMonthRequired: false,
    monthName: null,

    isDateRangeRequired: false,
    dateRangeName: null,

    isMinAgeRequired: false,
    minAgeName: null,

    isBlog: true
  },
];

